import React from 'react';
import styles from '../assets/css/booking.module.css';

const StepsIndicator = ({ toggleStep, activeStep, steps, goToSearch }) => (
  <div className={styles.steps_indicator_container}>
    <div className={styles.steps_indicator_inner_container}>
      {
        steps.map((step, index) => {
          return (
            <div className={step.key === activeStep ? styles.steps_indicator_active : styles.steps_indicator_step}
              key={step.id}
              style={index === steps.length - 1 ? { width: 'fit-content' } : {}}
              onClick={() => step.key === 'search' ? goToSearch() : toggleStep(step)}
            >
              {
                step.done ?
                  <span className="iconify steps_indicator_icon" data-icon="ic:round-check-circle"></span>
                  : <div className={styles.steps_indicator_circle}>{step.id}</div>
              }
              <p style={step.done ? { fontWeight: '700' } : {}}>{step.title}</p>

              { index !== steps.length -1 &&
               <div className={
                step.done || step.key === activeStep ?
                  styles.steps_indicator_bold_line
                  : styles.steps_indicator_line}>
               </div>}
            </div>
          );
        })
      }
    </div>
  </div>
);

export default StepsIndicator;